import { useState } from 'react';
import { resetPasswordApi } from '../../Service/ApiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { showSuccessAlert } from 'utils/SuccessMessage';

const ResetPasswordController = (initialState, validate) => {
  const location = useLocation();
  const { usercode } = location.state || {};

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (e.target.name === 'new_password') {
      const newPassValue = e.target.value; // take full input
      setFormData({ ...formData, [e.target.name]: newPassValue });

      // Validate immediately
      setErrors({
        ...errors,
        [e.target.name]: newPassValue.length < 8 ? 'Password must be at least 8 characters' : ''
      });
      return;
    }


    setFormData({ ...formData, [e.target.name]: inputValue });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const response = await resetPasswordApi(usercode, formData.new_password);
        if (response.success) {
          showSuccessAlert(response.msg, 'Successfull!');
          navigate('/login');
        } else {
          setApiError(response.msg);
        }
      } catch (error) {
        setApiError('Something went wrong!');
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    formData,
    errors,
    apiError,
    loading,
    handleChange,
    handleResetPassword
  };
};

export default ResetPasswordController;
